import React from 'react';

const StatItem = ({ title, description, imageSrc }) => {
    return (
        <div className="py-6">
            <div className="mb-5">
                <h3 className="text-xl font-bold text-[#001C3D] mb-3">{title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{description}</p>
            </div>
            <img
                src={imageSrc}
                alt={title}
                className="w-full rounded-2xl"
            />
        </div>
    );
};

const StatsSection = () => {
    const stats = [
        {
            title: "Filter by safety levels",
            description: "Restaurants, bakeries and cafe's are organized by their level of celiac awareness and gluten-free options. Find places that match your criteria so you can eat out with confidence.",
            imageSrc: "https://cdn.prod.website-files.com/5d53975001f72a80a5fdf1f2/65e44277f6dbffab7646b3f8_image%20(2)-p-800.png"
        },
        {
            title: "Reduce your gluten-free research",
            description: "Vetted information about every place's celiac accommodations, methods to avoid cross-contamination, and gluten-free options.",
            imageSrc: "https://cdn.prod.website-files.com/64f43e18cf3e00c9459e1d84/67daecac19d0e0e43feb40fe_Group%2019089.png"
        },
        {
            title: "Location-based search",
            description: "Find gluten-free spots by location, so you can quickly see what options are around you or what's in the area you're going to be in. Decrease the time you spend planning where to eat.",
            imageSrc: "https://cdn.prod.website-files.com/5d53975001f72a80a5fdf1f2/65df3a0a8e628a63e85ec5a5_image%20(6).png"
        },
        {
            title: "Built with dieticians and celiac experts",
            description: "We equip you with important information about each place to reduce the possibilities of getting sick or going hungry.",
            imageSrc: "https://cdn.prod.website-files.com/5d53975001f72a80a5fdf1f2/66323d6cce51b39cdb785715_image%20(6).png"
        },
        {
            title: "320K+ reviews by the celiac community",
            description: "See what people like you say about where they ate, so you can make an informed decision about where to eat. This app is designed for the celiac community. These are reviews you can trust.",
            imageSrc: "https://cdn.prod.website-files.com/5d53975001f72a80a5fdf1f2/65e085f413ec2878bb18421d_image%20(11).png"
        },
        {
            title: "Save for later",
            description: "Conveniently bookmark and save specific restaurants, bars, or cafés you want to try so you can plan in advance! Particularly useful for planning your trips.",
            imageSrc: "https://cdn.prod.website-files.com/5d53975001f72a80a5fdf1f2/65df390d60973c23a41c99a1_image%20(1).png"
        },
        {
            title: "Advanced food filters",
            description: "Search by cuisine, dining preferences, food type, place type, and other dietary restrictions so you can tailor your selection to your needs.",
            imageSrc: "https://cdn.prod.website-files.com/64f43e18cf3e00c9459e1d84/67daecac8e00e1fd5562dccc_Frame%2019442.png"
        }
    ];

    return (
        <div className="mt-6 space-y-8">
            {stats.map((stat, index) => (
                <StatItem
                    key={index}
                    title={stat.title}
                    description={stat.description}
                    imageSrc={stat.imageSrc}
                />
            ))}
        </div>
    );
};

export default StatsSection; 